import * as S from './style';

export default function CertificateForDownload({
  graduateName,
  startDate,
  endDate,
  round,
}: {
  graduateName: string;
  startDate: string;
  endDate: string;
  round: string;
}) {
  return (
    <S.Wrapper>
      <S.Download id='certificate'>
        <S.DownloadText>
          <S.DownloadName>{graduateName}</S.DownloadName>
          <S.Desc>
            위 사람은 교육기관 팀스파르타(주)가 <br />
            주관한 항해99 {round} 과정({startDate}~{endDate})을
            <br />
            성공적으로 수료하였으므로 이 증서를 수여합니다.
          </S.Desc>
        </S.DownloadText>
        <S.GraduateDate>{endDate}</S.GraduateDate>
        <S.Ceo>팀스파르타(주) 대표 이범규</S.Ceo>
      </S.Download>
    </S.Wrapper>
  );
}
